module.exports = __webpack_public_path__ + "img/Vendor.703d94a2.svg";